/*************************
 * @license
 * Copyright 2024 Myenergi Ltd. All rights reserved.
 * No part of this work may be reproduced, stored in a retrieval system of any nature, or transmitted, in any form or by any means without the prior written permission of Myenergi Ltd., the copyright owner.
 * If any unauthorised acts are carried out in relation to this copyright work, a civil claim for damages may be made and/or a criminal prosecution may result.
 *************************/
import { ApolloClient } from "@apollo/client";

export abstract class StoreBase {
  /**
   * The client property is assigned to an empty object here, but gets assigned an
   * actual apollo client instance when stores are created via the `createStores`
   * function in `Stores.ts`.
   */
  public client: ApolloClient<unknown> = {} as ApolloClient<unknown>;
}
